import React from "react";

import {queries} from "shared/api/queries";
import {useTranslation} from "react-i18next";
import {Checkbox} from "shared/ui";
import {SellerListType, ShippingSearchParamKey} from "features/shipping/types";
import {LoadingSpinner} from "shared/assets/svgs/LoadingSpinner";
import {useCsvCheckboxFilter} from "features/shipping/hooks/useCsvCheckboxFilter";

interface Props {
  value?: string | null;
}

const DEFAULT_FILTER = {allow_return: '1', ordering: "name"}
export const ReturnSellerFilter = ({value}: Props) => {
  const {t} = useTranslation(["shipping"]);
  const {
    checkAll,
    handleChangeChecked,
    handleCheckAll,
    isLoading,
    listData,
    options,
    selectedValues,
  } = useCsvCheckboxFilter<SellerListType>({
    fetchParams: DEFAULT_FILTER,
    queryKey: ShippingSearchParamKey.returnSellerUuids,
    url: queries.shop.list,
    value,
    toOption: (seller) => ({
      label: seller.name,
      value: seller.uuid,
      className: "item",
    }),
    toValue: (seller) => seller.uuid,
  });
  
  return (<div className={"column"}>
    <div className={"filter-title"}>
      <span>{t("return shop")}</span>
      <Checkbox rootClassName={"checkAll"} onChange={(event) => handleCheckAll(event.target.checked)}
                checked={checkAll}>
        전체
      </Checkbox>
    </div>
    <Checkbox.Group
      className={"check-group"}
      value={selectedValues}
      options={options}
      onChange={handleChangeChecked}
    />
    {!listData?.length ? (isLoading ? <LoadingSpinner /> : <span
      className={"nodata"}>데이터가 없습니다</span>) : null}
  </div>);
};
